import { goblinSummons } from './encounters/goblins.js';
import { coastFactionRelationships } from './encounters/factions.js';
import { emberCoast } from './maps/ember-coast.js';
import { adventurers } from './characters/adventurers.js';
import { coastEnemies } from './encounters/coast-enemies.js';
import { itemCatalog } from './items/healing-potions.js';
import { medicalKit } from './items/medical-kit.js';
import { equipmentItems } from './items/equipment.js';
import { readableItems, readableSites, readables } from './readables/index.js';
import { emberCoastSafePlaces } from './supplies/ember-coast-safe-places.js';
import { emberCoastCaches, emberCoastMerchants, emberCoastRewards } from './supplies/ember-coast-supplies.js';
import { classCatalog } from './classes/index.js';
import { emberCoastUsableProps } from './maps/ember-coast-usable-props.js';
import type { GameContent } from '../shared/game/world-types.js';
// Authored two-character animations register themselves as kinds of meeting.
import './pair-animations/index.js';
export { default as availableMaps } from './maps/catalog.json' with { type: 'json' };
export const gameContent: GameContent = { enemySummons: goblinSummons, factionRelationships: coastFactionRelationships, map: emberCoast, heroes: adventurers, enemies: coastEnemies,
  items: [...itemCatalog, medicalKit, ...equipmentItems, ...readableItems], readables, readableSites, merchants: emberCoastMerchants, caches: emberCoastCaches, rewards: emberCoastRewards, classes: classCatalog, safePlaces: emberCoastSafePlaces,
  usableProps: emberCoastUsableProps };

/** Each map loads its complete gameplay content, including encounters and supplies. */
export function contentForMap(mapId: string): GameContent {
  if (mapId !== gameContent.map.id) throw new Error('Select an available map for this instance.');
  return gameContent;
}
